import React from 'react';
import CourseHighlights from '../../Shared/Courses/CourseHighlights';
import CourseOperate from '../../Shared/Courses/CourseOperate';
import Cloud from '../../../img/Course-Elements/Cloud.png';

const FullStack = () => {
    return (
        <div className='px-4 md:px-12 pt-10'>
            <h4 className='text-blue-500 text-xl'>Certified Online Course</h4>
            <h1 className='text-blue-500 text-4xl font-semibold my-4'>Full Stack <span className='text-orange-400'>Development</span></h1>
            <h1 className='text-2xl font-semibold my-4'>increase the fee to Rs. 2699</h1>
            <h2 className=''>A web developer with full stack capabilities is one who can create both client and server applications.</h2>
            <h3 className='text-xl my-4 font-semibold'>8 Weeks, 45 min /day (3 Recorded+2 Live)</h3>
            <h5>Offer: Get flat Rs.200 off oby applying the promo code CAREERHikers</h5>
            <h1 className='text-5xl mt-4 font-bold'>Download the</h1>
            <h1 className='text-5xl mt-2 text-orange-500 font-bold'><span className='text-blue-500'>APP</span> Now!</h1>
            <CourseHighlights />
            <div className='flex mb-8 mt-12'>
                <div className='flex-1 md:mr-4'>
                    <h1 className='text-3xl font-semibold mb-6'>Why Should Study Full Stack Web Development?</h1>
                    <h2 className='text-xl my-2'>Create fantastic websites</h2>
                    <p>Created by Mark Zuckerberg, Facebook. Flipkart was established by Sachin Bansal. What will you build?</p>
                    <h1 className='text-2xl my-2'>have high demand</h1>
                    <h3>With 1.7 billion websites online, it is one of the most in-demand professions, with full stack engineers earning an average starting income of 6 LPA.</h3>
                    <h1 className='text-xl my-2'>Eat-Sleep-Code-Repeat</h1>
                    <p className='text-sm'>You think about coding whether it's sunny or rainy.</p>
                </div>
                <img className='flex-1' src={Cloud} alt="" />
            </div>
            <CourseOperate />
        </div>
    );
};

export default FullStack;